<!-- 下载报表 -->
<template>
    <div class="basis-page-cls">
        <section class="basis-cls_filter">
            <table-search :filterHeader="filterHeader" :defaultQuery="queryInfo" @filterSearch="filterSearch" />
        </section>

        <section class="basis-cls_table">
            <div class="header">
                <span class="title el-icon-document"> 下载报表</span>
            </div>
            <div class="table">
                <table-pagination
                    pagination
                    :data="list"
                    :column="column"
                    :total="total"
                    :page.sync="queryInfo.pageNum"
                    :limit.sync="queryInfo.pageSize"
                    @pagination="getReportList" />
            </div>
        </section>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import { parseTime } from '@/utils';


    export default {
        components: {
        },
        data() {
            return {
                // 列表数据
                column: [
	                // {
                    //     label: '任务ID',
                    //     prop: 'reportId',
                    //     minWidth: 90,
                    //     width: 90
                    // },
                    // {
                    //     label: '品牌',
                    //     prop: 'brandId',
                    //     minWidth: 100
                    // },
                    // { label: '接口名', prop: 'interfaceName', minWidth: 120 },
                    { label: '文件名', prop: 'reportName', minWidth: 150 },
                    { label: '导出状态', prop: 'reportStatus', minWidth: 120, width:100,
                        render: (h, scope)=>{
                            return <span>{this.getExportState(scope.row.reportStatus)}</span>
                        }
                    },
                    { label: '报错信息', prop: 'errorMessage', minWidth: 180 },
                    { label: '任务创建人', prop: 'createBy', minWidth: 180 },
                    { label: '创建时间', prop: 'createTime', minWidth: 180 },
                    {
                        label: '操作',
                        prop: 'cation',
                        align: 'center',
                        width: 100,
                        fixed: 'right',
                        render: (h, scope) => {
                            return (
                                <div>
                                {
                                    scope.row.reportStatus == 2&&
                                    <el-button
                                        onClick={() => this.downLoadReport(scope.row)}
                                        type="text">
                                        <a href={this.getDownLoadUrl(scope.row)}
                                        target="view_window">下载</a>
                                    </el-button>
                                }
                                </div>
                            )
                        }
                    }
                ],
                // ------------------------------------------------------------
                // 表头数据
                filterHeader: [
                    {
                        label: '品牌',
                        model: 'brandId',
                        type: 'select',
                        labelName: 'brandName',
                        valueName: 'brandIdentify',
                        default: [],
                        list: [],
                        placeholder: '请选择品牌'
                    },
                    {
                        label: '状态',
                        model: 'reportStatus',
                        type: 'select',
                        labelName: 'label',
                        valueName: 'value',
                        default: [],
                        list: [{
                        	label:"开始",
							value:"0"
                        },{
                            label:"执行中",
                            value:"1"
                        },{
                            label:"成功",
                            value:"2"
                        },{
                            label:"失败",
                            value:"3"
                        }],
                        placeholder:'请选择状态'
                    },
                    {
                        label: '报表名',
                        model: 'reportName',
                        type: 'input',
                        default: '',
                        placeholder: '请输入昵称'
                    },
                    {
                        label: '接口名',
                        model: 'interfaceName',
                        type: 'input',
                        default: '',
                        placeholder: '请输入登录名'
                    },
                    {
                        label: '导出任务创建时间',
                        model: 'datePicker',
                        type: 'datetimerange',
                        default: ''
                    }
                ],
                queryInfo: {
                    pageNum: 1,
                    pageSize: 10,
                    brandId: "",
                    interfaceName: "",
                    reportStatus: "",
                    reportName: "",
                    datePicker: "",
                    brandIdentify: '',
                    ect: "",
                    sct: ""
                },
                total: 0,
                // --------------------------------
                fileArr: [],
                fileBliong: false,

                // 分页后的列表数据
                list: []
            }
        },
        computed: {
            ...mapGetters([
                'userInfo',
                'subBrandList',
                'channelList'
            ])
        },
        watch: {
        },
        creat(){
        },
        mounted() {
            // this.queryInfo.brandId = this.userInfo.brandIdentify
            this.getReportList()
            this.getBrandList()
        },
        methods: {
            filterSearch(){
                this.getReportList();
            },

            // 获取品牌下拉项
            getBrandList(brandName) {
                this.$api.getBrandSelist({
                    data: {
                        // brandIdentify: this.queryInfo.brandIdentify,
                        // brandName: brandName
                    },
                    orderBy: '',
                    pageNum: 1,
                    pageSize: 50
                }).then(res => {
                    this.filterHeader[0]['list'] = res.list;
                })
            },

            // 获取导出数据列表
            getReportList() {
                this.$api.asyncreportControllerAsyncreportList({
                        pageNum: this.queryInfo.pageNum,
					   pageSize: this.queryInfo.pageSize,
					   orderBy: "asc",
					   data: {
					      brandId: this.queryInfo.brandId,
					      interfaceName: this.queryInfo.interfaceName,
					      startTime: this.queryInfo.datePicker ? parseTime(this.queryInfo.datePicker[0]) : '',
					      endTime: this.queryInfo.datePicker ? parseTime(this.queryInfo.datePicker[1]) : '',
					      reportStatus: this.queryInfo.reportStatus,
					      reportName: this.queryInfo.reportName,
					      createBy: this.queryInfo.brandId,
					   }
                }).then(res => {
                	console.log(`待下载报表`,res);
                    let code = res.errcode
                    if (code == 0) {
                        const { data } = res;
                        this.list = data.list

                        this.total = data.total
                    }
                }).catch(() => {
                })
            },


            getDownLoadUrl(row){
                return `${window.location.origin}/reportdonwload${row.reportZipUrl}`;
            },
            downLoadReport(row){
                /*console.log(`${window.location.origin}/reportdonwload${row.reportZipUrl}`);
            	let reportId = row.reportId;
            	this.$api.asyncreportControllerDownloadAsyncreport({
                    reportId
                }).then(res => {
                    let code = res.errcode
                    if (code == 0) {
                        this.$message({
                            type: 'success',
                            message: '下载成功!'
                        });
                    }
                }).catch(() => {
                })*/



              //   var myHeaders = new Headers();
              //       myHeaders.append("Authorization", localStorage.getItem("access_token"));
              // myHeaders.append("User-Agent", "apifox/1.0.0 (https://www.apifox.cn)");
              // myHeaders.append("Content-Type", "application/json");

              //       var raw = JSON.stringify({
              //          reportId
              //       });

              //       var requestOptions = {
              //          method: 'POST',
              //          headers: myHeaders,
              //          body: raw,
              //          redirect: 'follow'
              //       };

              //       fetch("https://ccaas-stg.ocssaas.com/ocs-async-report/asyncreportController/downloadAsyncreport", requestOptions)
              //      .then(response => response.text())
              //      .then(result => console.log(result))
              //      .catch(error => console.log('error', error));
            },

            getExportState(code){
                if( code == 0 ) return "开始";
                if( code == 1 ) return "执行中";
                if( code == 2 ) return "成功";
                if( code == 3 ) return "失败";
            }
        },
    }
</script>

<style lang="scss" scoped>
</style>
